import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { Link, graphql } from 'gatsby'
import SeminarTypes from "../../components/seminar/seminar-types"
import SeminarStatus from "../../components/seminar/seminar-status"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import DisplayOccupationPosition from "../../components/community/display-occupation-position"
import RelatedComponents from "../../components/related-components"
import "../../styles/pc/page/seminar_post.scss"
import "../../styles/sp/page/seminar_post.scss"

export default function SeminarPost({ data }) {
  const info = data.microcmsSeminars

  let seminarName = ''
  let seminarType = ''
  if (info.category.includes("コンセプト")) {
    seminarName = "コンセプトセミナー"
    seminarType = "category/concept"
  } else if(info.category.includes("ナレッジ")) {
    seminarName = "ナレッジセミナー"
    seminarType = 'category/knowledge'
  } else if(info.category.includes("対話")) {
    seminarName = "対話セミナー"
    seminarType = 'category/dialogue'
  } else {
    seminarName = "リフレクションラウンドテーブル"
    seminarType = 'category/rrt'
  }

  let seminarStatus = ''
  let seminarButtonStatus = ''
  if (info.status.includes("参加受付中")) {
    seminarStatus = "申し込み受付中です"
    seminarButtonStatus = <div className="reception_btn" style={{marginTop: '0px'}}><Link to={ info.apply_url }>このセミナーを申し込む</Link></div>
  } else if(info.status.includes("受付終了")) {
    seminarStatus = "申し込み受付は終了しました"
    seminarButtonStatus = <div className="semiar_now_btn" style={{marginTop: '0px'}}><Link>受付終了</Link></div>
  } else {
    seminarStatus = "開催終了しました"
    seminarButtonStatus = <div className="seminar_close_btn" style={{marginTop: '0px'}}><Link>開催終了</Link></div>
  }

  function getFasciliatorType(person_type) {
    let fasciliatorType = ''
    if (person_type.includes("メンバー")) {
      fasciliatorType = "member"
    } else if(person_type.includes("パートナー")) {
      fasciliatorType = "partner"
    } else {
      fasciliatorType = "collaborator"
    }

    return fasciliatorType
  }

  return (
    <Layout isSeminar={true}>
      <Seo
        type="article"
        title="セミナー　詳細"
        description=""
        bobyClassName="menu8"
      />
      <div className="wrapper seminar_post">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/seminar">Seminar</Link>　/　<Link to={`/seminar/` + info.seminarsId } className="current">{ info.title }</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        <div className="contents_01 detail">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              <div className="inner_category_title t_left">
                {/* <div className="category_title">
                  <Link to={'/seminar'} >
                    Seminar
                  </Link>
                </div> */}
                <div className="seminar_detail">
                  <div className="seminar_detail_l">
                    <div className="contents_box mv_box">
                      <img src={info.image ? info.image.url : ''} alt="セミナー詳細" />
                    </div>
                    <div className="seminar_title">{info.title}</div>
                    <div className="seminar_title_sub">{info.subtitle}</div>
                    <div>
                      {/* {info.tags.forEach(tag => <p title>{tag.name}</p>)} */}
                    </div>
                    <div className="detail_box sp_only">
                      <div className="detail_box_in">
                        <div className="category_title"><Link to={`/seminar/${seminarType}`}>{seminarName}</Link></div>
                        <div>
                          <SeminarTypes types={info.types} />
                        </div>

                        <div className="detail_title">開催日程：</div>
                        <ul>
                          <li><div dangerouslySetInnerHTML={{__html: info.detail_event_date ? info.detail_event_date.replace(/\n/g, '<br />') : ''}} /></li>
                        </ul>

                        <div className="detail_title">会場：</div>
                        <div dangerouslySetInnerHTML={{__html: info.venue ? info.venue.replace(/\n/g, '<br />') : ''}}/>
                      </div>
                      {seminarButtonStatus}
                      <div className="reception_txt">{seminarStatus}</div>
                    </div>
                    <h4 className="seminar_title">詳細情報</h4>
                    <div dangerouslySetInnerHTML={{ __html: info.body}} />

                    { Object.keys(info.fasciliator).length ?
                      <>
                      <h4 className="seminar_title">ファシリテーター</h4>
                      <div className="community_wrap">
                        <ul className="community_box">
                          {info.fasciliator.map((person) => (
                            <Link key={person.id} to={`/community/${getFasciliatorType(person.person_type)}/${person.id}`}>
                              <li>
                                <span className="community_box_img"><LazyAndPreloadImage imgUrl={person.list_face_image ? person.list_face_image.url : ''} alt="ファシリテーター一覧" /></span>
                                <span className="fs13">{person.name}</span><span className="fs12"><DisplayOccupationPosition position={person.position} occupation={person.occupation} /></span>
                              </li>
                            </Link>
                          ))}
                        </ul>
                      </div>
                      </>
                      : ''
                    }

                    <h4 className="seminar_title">会場のご案内</h4>
                    <div dangerouslySetInnerHTML={{ __html: info.venue ? info.venue : ''}} />

                    <h4 className="seminar_title">備考</h4>
                    <div dangerouslySetInnerHTML={{__html: info.remarks ? info.remarks.replace(/\n/g, '<br />') : ''}} />

                    <div style={{marginTop: '56px'}} />

                    { info.download_url_title ?
                        <>
                          <div className="bnr_box">
                            <Link to={info.download_file_url ? info.download_file_url.url : ''}><span>{info.download_url_title}</span></Link>
                          </div>
                        </>
                        : ''
                    }
                    { info.download_url_title_2 ?
                        <>
                          <div className="bnr_box">
                            <Link to={info.download_file_url_2 ? info.download_file_url_2.url : ''}><span>{info.download_url_title_2}</span></Link>
                          </div>
                        </>
                        : ''
                    }
                    { info.download_url_title_3 ?
                        <>
                          <div className="bnr_box">
                            <Link to={info.download_file_url_3 ? info.download_file_url_3.url : ''}><span>{info.download_url_title_3}</span></Link>
                          </div>
                        </>
                        : ''
                    }

                    <div className="sp_btn sp_only">
                      {seminarButtonStatus}
                      <div className="reception_txt">{seminarStatus}</div>
                    </div>

                    {/* MEMO 参加受付中のセミナーを一時廃止（不要の可能性） */}
                    {/* { 
                      data.allMicrocmsSeminars ?
                      <>
                      <div className="inner_title">
                        <div className="inner_title_in">
                          <h4 className="maintitle"><span>Seminar</span></h4>
                          <p className="subtitle"><span>参加受付中のセミナー</span></p>
                        </div>
                        <div className="more"><Link to="/seminar"><span>view more</span></Link></div>
                        </div>
                        <div className="flex_wrap">
                        {data.allMicrocmsSeminars.edges.map(({ node }) => (
                          <div key={node.seminarsId} className="flex_contents">
                            <Link to={'/seminar/' + node.seminarsId}>
                              <div className="contents_box">
                                <LazyAndPreloadImage imgUrl={node.image ? node.image.url : ''} alt="参加受付中のセミナー一覧" />
                                <SeminarStatus status={node.status} />
                              </div>
                              <SeminarTypes types={node.types} />
                              <div className="seminar_title">{node.title}</div>
                              開催日程：<div className="data" dangerouslySetInnerHTML={{__html: node.detail_event_date ? node.detail_event_date.replace(/\n/g, '<br />') : ''}}/>
                              <div className="seminar_tag">
                                {node.tags.map((tag) => (
                                  tag.type[0] === "セミナータグ" ? <p key={tag.id}>#{tag.name}</p> : ''
                                ))}
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                      </>

                      : ''
                    } */}

                  <RelatedComponents
                    relatedPrograms={info.related_programs}
                    relatedSeminars={info.related_seminars}
                    relatedArticles={info.related_articles}
                    relatedBooks={info.related_books}
                  />

                  </div>
                  <div className="seminar_detail_r">
                    <div className="detail_box pc_only">
                      <div className="detail_box_in">
                        <div className="category_title"><Link to={`/seminar/${seminarType}`}>{seminarName}</Link></div>
                        <div>
                          <SeminarTypes types={info.types} />
                        </div>

                        <div className="detail_title">開催日程:</div>
                        <ul>
                          <li><div className="detail_description" dangerouslySetInnerHTML={{__html: info.detail_event_date ? info.detail_event_date.replace(/\n/g, '<br />') : ''}} /></li>
                        </ul>

                        <div className="detail_title">会場:</div>
                        <div className="detail_description" dangerouslySetInnerHTML={{__html: info.venue ? info.venue.replace(/\n/g, '<br />') : ''}}/>
                      </div>
                      {seminarButtonStatus}
                      <div className="reception_txt">{seminarStatus}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
        </div>{/* main */}
        <div className="page_title fixed">
          <div className="right_page_ttl"><span className="vertical">Seminar - </span><span className="txt">一緒に探求する場</span></div>
        </div>{/* right page_title */}
      </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}

export const query = graphql`
query SeminarIdQuery($id: String!) {
  microcmsSeminars(seminarsId: {eq: $id}) {
    seminarsId
    image {
      url
    }
    title
    subtitle
    body
    detail_event_date
    venue
    status
    category
    types
    remarks
    apply_url
    download_url_title
    download_file_url {
      url
    }
    download_url_title_2
    download_file_url_2 {
      url
    }
    download_url_title_3
    download_file_url_3 {
      url
    }
    fasciliator {
      id
      list_face_image {
        url
      }
      name
      position
      occupation
      person_type
    }
    related_books {
      id
      title
      display_image {
        url
      }
    }
    related_articles {
      id
      thumbnail {
        url
      }
      title
      middle_category {
        id
        name
        display_color
      }
      tags {
        id
        name
        type
      }
    }
    related_programs {
      id
      thumbnail {
        url
      }
      title
      subtitle
      task_tags {
        id
        name
        type
      }
      hierarchy_tags {
        id
        name
        type
      }
    }
    related_seminars {
      id
      image {
        url
      }
      status
      title
      display_event_date
      tags {
        id
        name
        type
      }
      types
    }
  }
  allMicrocmsSeminars(
    limit: 2,
    filter: {seminarsId: {ne: $id}, status: {eq: "参加受付中"}},
    sort: {fields: [publishedAt], order: DESC}
  ) {
    edges {
      node {
        seminarsId
        title
        image {
          url
        }
        status
        types
        detail_event_date
        tags {
          id
          name
          type
        }
      }
    }
  }
}`
